import { FC } from 'react';
import { connect } from 'react-redux';

import { Button } from 'components';
import { cn } from 'utils/cn';
import { goToFile } from './_actions';
import { getSelectedFileIndex } from './_selectors';

interface ITextNavigation {
  selectedFileIndex?: number;
  index: number;
  fileName: string;
  goToFile?: (newIndex: number) => void;
}

const TextNavigation: FC<ITextNavigation> = ({ fileName, index, selectedFileIndex, goToFile }) => {
  const isSelected = index === selectedFileIndex;
  return (
    <Button
      size="small"
      variant="outlined"
      sizeIcon="small"
      onClick={() => goToFile?.(index)}
      className={cn(
        'delay-100 duration-200',
        '!h-8 !w-fit !rounded-3xl !border',
        '!m-0 gap-1 !px-2 !py-1',
        isSelected
          ? '!border-primary-blue-100 !bg-primary-blue-900'
          : '!border-tertiary-600 !bg-tertiary-800'
      )}
      classNameTypography={cn(
        '!m-0 !p-0 text-sm',
        isSelected ? 'font-light !text-primary-blue-100' : 'font-light !text-tertiary-200'
      )}
    >
      {fileName}
    </Button>
  );
};

export default connect(
  (state) => ({
    selectedFileIndex: getSelectedFileIndex(state)
  }),
  { goToFile }
)(TextNavigation);
